export const dialogConfigs = {
    createParty: {
        title: "Create Party",
        fields: [
            {
                name: "partyName",
                label: "Party Name",
                type: "text" as const,
                placeholder: "Enter",
                required: true
            },
            {
                name: "partyType",
                label: "Party Type",
                type: "select" as const,
                options: [
                    { value: "Merchant", label: "Merchant" },
                    { value: "Compatio", label: "Compatio" },
                    { value: "Provider", label: "Provider" },
                    { value: "Customer", label: "Customer" },
                    { value: "Seller", label: "Customer" },
                ],
                required: true
            },
            {
                name: "address",
                label: "Address",
                type: "text" as const,
                placeholder: "Enter",
                required: true
            }
        ]
    },

    createDomain: {
        title: "Create Domain",
        fields: [
            {
                name: "domainName",
                label: "Domain Name",
                type: "text" as const,
                placeholder: "Enter",
                required: true
            },
            {
                name: "description",
                label: "Description",
                type: "textarea" as const,
                placeholder: "Enter",
                required: false
            }
        ]
    },

    createChannel: {
        title: "Create Channel",
        fields: [
            {
                name: "channelName",
                label: "Channel Name",
                type: "text" as const,
                placeholder: "Enter",
                required: true
            }
        ]
    },

    addEnvironment: {
        title: "Add Environment",
        fields: [
            {
                name: "environmentName",
                label: "Environment Name",
                type: "text" as const,
                placeholder: "Enter Environment Name",
                required: true
            },
            {
                name: "useAsProduction",
                label: "",
                type: "checkbox" as const,
                placeholder: "Use this as 'Production Environment'",
                defaultValue: false
            }
        ]
    },

    environmentFields: {
        platformInfo: [
            { value: "shopify", label: "Shopify" },
            { value: "magento", label: "Magento" },
            { value: "custom", label: "Custom" },
        ],
        thirdPartyPriceEngine: [
            { value: "none", label: "None" },
            { value: "dynamodb", label: "DynamoDB" },
            { value: "redis", label: "Redis" },
            { value: "elasticsearch", label: "Elasticsearch" },
        ],
    }
};